import React from "react";
import { InfoIcon } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { StreamPanel } from "../components/demo/StreamPanel";
import { PitchControl } from "../components/demo/PitchControl";
import { Leaderboard } from "../components/demo/Leaderboard";
export function DemoDay() {
  return <main className="mx-auto max-w-6xl px-5 py-10 md:px-8 md:py-12" data-id="element-816" data-mp="1vlfzlgy2259n">
      <PageHeader title="Demo Day" description="Tuesday, October 13 · Live pitches to investors, scored by AI against the published criteria." data-id="element-817" data-mp="1zmri72iihq8c" />

      <p className="mt-6 flex items-start gap-2 rounded-xl bg-bryellow/15 px-4 py-3 text-sm" data-id="element-818" data-mp="24n5tctfetgal">
        <InfoIcon className="mt-0.5 h-4 w-4 shrink-0 text-saffron-ink" aria-hidden="true" data-id="element-819" data-mp="29il2j82h2o0o" />
        <span data-id="element-820" data-mp="2ehfuazif3mwx">
          The AI judge is in preview mode and produces simulated scores weighted by each team's recorded progress. Connect
          an AI provider in the Integrations panel to score live pitch transcripts. Investors confirm the final ranking.
        </span>
      </p>

      <div className="mt-8 grid gap-8 lg:grid-cols-[1fr_380px]" data-id="element-821" data-mp="1co2dttz44w38">
        <StreamPanel data-id="element-822" data-mp="17vhholsqi6wj" />
        <PitchControl data-id="element-823" data-mp="17u6gmtqobd94" />
      </div>

      <div className="mt-12" data-id="element-824" data-mp="17ty1swazpxva">
        <Leaderboard data-id="element-825" data-mp="12w4uu11v4zty" />
      </div>
    </main>;
}